// toastHelper.ts
type ShowToastFunction = (toast: any) => void;

let showToastFunction: ShowToastFunction | null = null;

/**
 * Sets the global showToast function.
 * This function should be called once inside a React component using the `useToast` hook.
 * @param showToast - The showToast function from `useToast`.
 */
export const setShowToastFunction = (showToast: ShowToastFunction) => {
	showToastFunction = showToast;
};

/**
 * Helper function to show a toast message globally.
 * @param {Object} toast - The toast configuration object.
 */
export const showToast = (toast: any) => {
	if (showToastFunction) {
		showToastFunction(toast);
	} else {
		console.error(
			"showToastFunction is not initialized. Ensure setShowToastFunction is called.",
		);
	}
};
